import script from "./PopupTool1.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool1.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool1.vue?vue&type=style&index=0&id=b3f06a26&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3f06a26"]])

export default __exports__